<template>
  <div class="app-container">
    <div class="filter-container">
      学校:
      <el-select
        v-model="listQuery.school_id"
        placeholder="请选择学校"
        style="width: 150px"
        class="filter-item"
      >
        <el-option
          v-for="item in school_list"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      学生姓名/学号:
      <el-input
        v-model="listQuery.keyword"
        placeholder="请输入学生姓名/学号"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      题目:
      <el-input
        v-model="listQuery.title"
        placeholder="请输入题目"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      答题时间:
      <el-date-picker
        class="filter-item"
        v-model="dateArr"
        type="datetimerange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd HH:mm:ss"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>
      <el-button class="filter-item" type="primary" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="学校" min-width="110" align="center">
        <template slot-scope="scope">
          {{
            type == 1
              ? scope.row.student.college
                ? scope.row.student.college.school.name
                : "-"
              : scope.row.teacher.college
              ? scope.row.teacher.college.school.name
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column
        :label="type == 1 ? '学生姓名' : '教师姓名'"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          {{ type == 1 ? scope.row.student.name : scope.row.teacher.name }}
        </template>
      </el-table-column>
      <el-table-column
        :label="type == 1 ? '学生ID' : '教师ID'"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          {{ type == 1 ? scope.row.student.id : scope.row.teacher_id }}
        </template>
      </el-table-column>
      <el-table-column label="题目" min-width="110" align="center">
        <template slot-scope="scope">
          {{
            type == 1
              ? scope.row.student_question_bank.title
              : scope.row.teacher_question_bank.title
          }}
        </template>
      </el-table-column>
      <el-table-column label="答案" min-width="110" align="center">
        <template slot-scope="scope">
          {{
            type == 1
              ? scope.row.student_question_bank.answer
              : scope.row.teacher_question_bank.answer
          }}
        </template>
      </el-table-column>
      <el-table-column label="回答内容" min-width="110" align="center">
        <template slot-scope="scope">
          {{ type == 1 ? scope.row.answer : scope.row.answer }}
        </template>
      </el-table-column>
      <el-table-column label="答题时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.answer_at }}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleDetail(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      title="查看详情"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form label-width="160px" v-if="form.answer_at">
        <el-form-item label="学校">
          {{ form ? form.student.college.school.name : "-" }}
        </el-form-item>
        <el-form-item :label="type == 1 ? '学生姓名' : '教师姓名'">
          {{ form ? form.student.name : "-" }}
        </el-form-item>
        <el-form-item :label="type == 1 ? '学生ID' : '教师ID'">
          {{ form ? form.student.id : "-" }}
        </el-form-item>
        <el-form-item label="题目">
          {{ form ? form.student_question_bank.title : "-" }}
        </el-form-item>
        <el-form-item label="答案">
          {{ form ? form.student_question_bank.answer : "-" }}
        </el-form-item>
        <el-form-item label="答题时间">
          {{ form ? form.answer_at : "-" }}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogFormVisible = false">取消</el-button> -->
        <el-button
          type="primary"
          @click="dialogFormVisible = false"
          :loading="btnLoading"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: [],
      school_list: [],
      total: null,
      listLoading: false,
      dateArr: null,
      listQuery: {
        page: 1,
        limit: 10,
        id: "",
        start_at: "",
        end_at: "",
        nickname: "",
        title: "",
        comment_content: "",
      },
      dialogFormVisible: false,
      form: {},
      rules: {
        name: [{ required: true, message: "院系不能为空", trigger: "change" }],
      },
      btnLoading: false,
      type: null,
      id: "",
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.id = this.$route.query.id;
    this.getList();
    this.getSchoolList();
  },
  watch: {
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0];
        this.listQuery.end_at = newVal[1];
      } else {
        this.listQuery.start_at = "";
        this.listQuery.end_at = "";
      }
    },
  },
  methods: {
    getSchoolList() {
      request({
        url: "/api/backend/school/list",
        method: "get",
        params: { limit: 99999999999999 },
      }).then((response) => {
        this.school_list = response.data.data;
      });
    },
    getList() {
      let url = "";
      if (this.type == 1) {
        url = "/api/backend/studentQuestionBank/answerLog";
        this.listQuery.student_question_bank_id = this.id;
      } else {
        url = "/api/backend/teacherQuestionBank/answerLog";
        this.listQuery.teacher_question_bank_id = this.id;
      }
      //teacherQuestionBank/answerLog
      //studentQuestionBank/answerLog
      this.listLoading = true;
      request({
        url: url,
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.listLoading = false;
        //处理答案
        this.list.forEach((item) => {
          //单选题
          if (this.type == 1) {
            if (item.student_question_bank.type == 1) {
              item.answer = String.fromCharCode(item.answer);
              item.student_question_bank.answer = String.fromCharCode(
                item.student_question_bank.answer
              );
            } else if (item.student_question_bank.type == 2) {
              //多选题
              let itemanswer = "";
              let answer = "";
              item.answer.split(",").forEach((item) => {
                console.log(item);
                if (!itemanswer) {
                  itemanswer = String.fromCharCode(item);
                } else {
                  itemanswer = itemanswer + "," + String.fromCharCode(item);
                }
              });
              item.answer = itemanswer;
              item.student_question_bank.answer.split(",").forEach((item) => {
                if (!answer) {
                  answer = String.fromCharCode(item);
                } else {
                  answer = answer + "," + String.fromCharCode(item);
                }
              });
              item.student_question_bank.answer = answer;
              this.$forceUpdate(); //强制更新
            }
          } else {
            if (item.teacher_question_bank.type == 1) {
              item.answer = String.fromCharCode(item.answer);
              item.teacher_question_bank.answer = String.fromCharCode(
                item.teacher_question_bank.answer
              );
            } else if (item.teacher_question_bank.type == 2) {
              //多选题
              let itemanswer = "";
              let answer = "";
              item.answer.split(",").forEach((item) => {
                console.log(item);
                if (!itemanswer) {
                  itemanswer = String.fromCharCode(item);
                } else {
                  itemanswer = itemanswer + "," + String.fromCharCode(item);
                }
              });
              item.answer = itemanswer;
              item.teacher_question_bank.answer.split(",").forEach((item) => {
                if (!answer) {
                  answer = String.fromCharCode(item);
                } else {
                  answer = answer + "," + String.fromCharCode(item);
                }
              });
              item.teacher_question_bank.answer = answer;
            }
          }
        });

        this.total = response.data.total;
      });
    },
    getDetail(id) {
      request({
        url: "/api/backend/post/commentDetail",
        method: "get",
        params: { id },
      }).then((response) => {});
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        // id: "",
        // name: "",
      };
    },
    handleDetail(row) {
      // this.resetForm();
      this.form = row;
      this.dialogFormVisible = true;
      // this.$nextTick(() => {
      //   this.$refs["form"].clearValidate();
      // });
      //   this.getDetail(row.id);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
